<script setup lang="ts">
    const { label } = defineProps({
        label: {
            type: String,
            default: "",
        },
    });

    const generatedId = useId();

    // const generatedId = `label-${Math.random().toString(36).substr(2, 9)}`;
</script>
<template>
    <label :id="generatedId" class="text-subtitle-1 text-medium-emphasis">{{
        label
    }}</label>
    <slot name="default" :aria-labelledby="generatedId" />
</template>
